import {useEffect, useState} from 'react';
import {Alert, Button, Input, styles, Surface, Text, useTheme} from '../tmwx-design-web/src';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {isEmpty} from '../gui-common/appHelper';
import {
    initialSetupPasswordRequest,
    isSetupPasswordRequestValid,
    SetupPasswordRequest
} from '../gui-common/redux/data/auth';
import {RootState} from '../gui-common/redux/store';
import {ResponseBase} from '../gui-common/redux/data';
import {useNavigate, useSearchParams} from "react-router-dom";
import {setSnackbarData} from "gui-common/redux/action/snackbarAction";
import {logout, setupPassword} from "gui-common/redux/action/portal/authAction";

const PasswordSetup = () => {
    const { t } = useTranslation()
    const dispatch: any = useDispatch()
    const navigate = useNavigate();
    const { padding, colors } = useTheme()
    const [request, setRequest] = useState<SetupPasswordRequest>(initialSetupPasswordRequest)
    const [confirmRequest, setConfirmRequest] = useState<SetupPasswordRequest>(initialSetupPasswordRequest)
    const [validationError, setValidationError] = useState<string | null>(null)
    const [searchParams, setSearchParams] = useSearchParams();
    const response = useSelector<RootState, ResponseBase | null>(state => state.auth.response);


    useEffect(() => {
        const token = searchParams.get("token") as string;
        if (!isEmpty(token)) {
            setRequest({ ...request, token: token });
        }
    }, [searchParams])

    useEffect(() => {
        if (response) {
            if (response.responseCode === 'SUCCESS') {
                dispatch(setSnackbarData({
                    status: 'success',
                    text: t('actionSuccess')
                }))
                dispatch(logout())
                navigate('/sign-in')
            } else {
                dispatch(setSnackbarData({
                    status: 'danger',
                    text: t('actionFailed')
                }))
            }
        }
    }, [response])

    const handleSetupPassword = () => {
        setValidationError(null)

        if (!request.password || !confirmRequest.password) {
            setValidationError(t('mandatoryFields'));
            return;
        }

        if (request.password !== confirmRequest.password) {
            setValidationError(t('password.confirmNotSame'));
            return;
        }

        if (isSetupPasswordRequestValid(request)) {
            dispatch(setupPassword(request));
        } else {
            setValidationError(t('password.subtitle'));
        }
    }

    return (
        <Surface style={{ height: '100vh', background: `linear-gradient(to right, ${colors.primary}, ${colors.status.info})` }} elevation={3}>

            <Surface style={{
                ...styles.center, ...{
                    height: '80vh',
                    padding: padding,
                    paddingTop: padding * 2,
                    paddingBottom: padding * 2
                }
            }}>
                <Surface style={{width: '100%', maxWidth: 500}}>
                    <Text variant='title' bold>
                        {t('password.setupPassword')}
                    </Text>
                    <Text secondary>
                        {t('password.setupPasswordText')}
                    </Text>

                    {(validationError && !isEmpty(validationError)) &&
                        <Alert style={styles.marginTop8} text={validationError} status='danger'/>}

                    <div onKeyDown={(e: any) => {
                        var code = e.keyCode || e.which;
                        if (code === 13) { //13 is the enter keycode
                            handleSetupPassword()
                        }
                    }}>
                        <Input
                            style={styles.marginTop8}
                            placeholder={t('signIn.password')}
                            variant='password'
                            value={request.password}
                            error={!isEmpty(validationError)}
                            onChangeValue={text => setRequest({...request, password: text})}
                        />

                        <Input
                            style={styles.marginTop8}
                            placeholder={t('password.confirmPassword')}
                            variant='password'
                            value={confirmRequest.password}
                            error={!isEmpty(validationError)}
                            onChangeValue={text => setConfirmRequest({...confirmRequest, password: text})}
                        />
                    </div>

                    <Button
                        fullWidth
                        style={styles.marginTop16}
                        status='primary'
                        iconLeft={'send'}
                        iconProvider='Feather'
                        onPress={handleSetupPassword}
                    >
                        {t('password.setupPassword')}
                    </Button>
                </Surface>
            </Surface>
        </Surface>
    );
};

export default PasswordSetup;